import React, { Component } from 'react'
import Brand from '../../assets/img/maw-brand.png'

function Navbar() {

    const _MenuActive = () => {
        document.getElementById('menu').classList.toggle('active')
        document.getElementById('hamburguer').classList.toggle('active')
    }

    return (
        <header className="header" id="header">
            <div className="hamburguer" id="hamburguer">
                <div onClick={_MenuActive} className="hamburguer_wrapper">
                    <span className="bars bar-1"></span>
                    <span className="bars bar-2"></span>
                    <span className="bars bar-3"></span>
                </div>

                <span onClick={_MenuActive} className="brand">
                    MENU
                </span>
            </div>

            <nav className="menu" id="menu">
                <div onClick={_MenuActive} className="close">
                </div>

                <a onClick={_MenuActive} href="#up">Inicio</a>
                <a onClick={_MenuActive} id="aboutToggle" href="#about">Sobre mí</a>
                <a onClick={_MenuActive} href="#portfolio">Portfolio</a>
                <a onClick={_MenuActive} href="#contact">Contacto</a>
            </nav>
        </header>
    )
}

class Header extends Component {
    render(){
        return(
            <Navbar />
        )
    }
}

export default Header;